if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.blockId = this.dataset.blockId;
        this.block = this.closest(`[data-id="${this.blockId}"`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      // UPDATED: Stops theme from destroying mobile view

     init() {
  this.initSlider();
}

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window
          .getComputedStyle(this.sliderWrapper)
          .getPropertyValue('--f-column-gap');

        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
      // UPDATED: SLides per view = 2 visible on mobile
          slidesPerView: 2,
          spaceBetween: spaceBetween,

          navigation: {
            nextEl: this.block.querySelector(this.selectors.nextEl),
            prevEl: this.block.querySelector(this.selectors.prevEl),
          },

          pagination: {
            el: this.block.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },

          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },

            1024: {
              slidesPerView: this.laptopItems,
            },

            1280: {
              slidesPerView: this.items,
            },
          },

          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
      

          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);

        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        // CUSTOM: Initialise Featured Collection Swiper on mobile.
// Required for mobile previous/next navigation buttons to function.
        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          this.sliderOptions,
          [FoxTheme.Swiper.Mousewheel]
        );

        this.sliderInstance.init();
 // Makes Progress bar stay visible for fetaured collections
      const progressBar = this.block.querySelector('scroll-progress-bar');

if (progressBar) {
  progressBar.style.display = 'block';
}
//Makes progress bar respond to button clicks
        this.sliderInstance.slider.on('progress', (swiper, progress) => {
  const progressBar = this.block.querySelector('.progress-bar');

  if (progressBar) {
    progressBar.style.width = `${progress * 100}%`;
  }
});

this.calcNavButtonsPosition();
this.fixQuickviewDuplicate();
}

destroySlider() {
        this.classList.remove(this.classes.swiper);

        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        if (typeof this.sliderInstance !== 'object') return;

        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];

        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');

          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        const controls = this.block.querySelector('.swiper-controls');

        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }
    }
  );
}